import React from 'react';
import IGLiveSlideoutBannerNormalSrc from './IGLiveSlideoutBanner_normal.png';
import IGLiveSlideoutBannerWhiteSrc from './IGLiveSlideoutBanner_white.png';

export const IGLiveSlideoutBanner = ({
  textColor,
}: {
  textColor: 'white' | 'normal';
}) => {
  return textColor === 'white' ? (
    <img src={IGLiveSlideoutBannerWhiteSrc} />
  ) : (
    <img src={IGLiveSlideoutBannerNormalSrc} />
  );
};
